import { render, staticRenderFns } from "./DashboardStatCard.vue?vue&type=template&id=97106ab2&scoped=true&"
import script from "./DashboardStatCard.vue?vue&type=script&lang=js&"
export * from "./DashboardStatCard.vue?vue&type=script&lang=js&"
import style0 from "./DashboardStatCard.vue?vue&type=style&index=0&id=97106ab2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97106ab2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VAvatar,VCard,VCardText,VIcon,VSkeletonLoader})
